import { render, staticRenderFns } from "./EditPages.vue?vue&type=template&id=247df9d2&scoped=true&"
import script from "./EditPages.vue?vue&type=script&lang=js&"
export * from "./EditPages.vue?vue&type=script&lang=js&"
import style0 from "../../assets/scss/document_edit.scss?vue&type=style&index=0&id=247df9d2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247df9d2",
  null
  
)

export default component.exports